import { useState } from 'react';

interface UseSidebarCollapseProps {
  initialCollapsed?: boolean;
  onCollapse?: (collapsed: boolean) => void;
}

export const useSidebarCollapse = ({ initialCollapsed = false, onCollapse }: UseSidebarCollapseProps) => {
  const [internalCollapsed, setInternalCollapsed] = useState(initialCollapsed);

  const handleCollapse = (value: boolean) => {
    setInternalCollapsed(value);
    onCollapse?.(value);
  };

  return {
    internalCollapsed,
    handleCollapse,
  };
};
